// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import { useQuery, type UseQueryResult } from 'react-query'

import { Template } from '@/services/tcc/configurator'
import { getTemplate } from '@/services/templates'

export const queryKey = (templateId: string) =>
  ['GetTemplate', templateId] as const

export const useGetTemplate = (
  templateId?: string
): UseQueryResult<Template | undefined, Error> => {
  return useQuery(
    queryKey(templateId ?? ''),
    async () => {
      if (!templateId) throw new Error('No template ID provided')

      return getTemplate(templateId)
    },
    {
      enabled: Boolean(templateId),
    }
  )
}
